module.exports = __webpack_public_path__ + "static/media/Gardeshgari.2bfd58d4.svg";